import Appxigon from './appxigon'
import { AXGSchema, AXGView, AXGState, AXGAccount, AXGData } from './redux/reducers'
import configureStore from './redux/store'
import * as AppxigonActions from './redux/actions'
import Item from './item.js'
import app from '../package.json'

module.exports = {
  Appxigon,
  AppxigonActions,
  AppxigonItem: Item,
  AXGSchema,
  AXGView,
  AXGState,
  AXGAccount,
  AXGData,
  configureStore,
  version: app.version,
}



// WEBPACK FOOTER //
// ./index.js